<svg xmlns="http://www.w3.org/2000/svg" width="67" height="48" viewBox="0 0 67 48" fill="none">
  <path d="M1.56641 22.4108L23.361 44.2054L65.5664 2" stroke="white" stroke-width="4"/>
</svg>